import React, { Fragment, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SvgIcon from "../../Components/Common/Component/SvgIcon";
import CustomizerContext from "../../_helper/Customizer";
import { MENUITEMS } from "./Menu";
import IconRenderer from "./IconRenderer";
import PrivilegeContext from "../../_helper/PrivilegeContext";
import { useClinicAdmin } from "../../_helper/ClinicProvider";

const SidebarMenuItems = ({ setMainMenu, sidebartoogle, setNavActive, activeClass }) => {
  const { layout } = useContext(CustomizerContext);
  const { clinicAdmin } = useClinicAdmin();
  const { privileges } = useContext(PrivilegeContext);
  const [menu, setMenu] = useState([])
  const layout1 = localStorage.getItem("sidebar_layout") || layout;

  const id = window.location.pathname.split("/").pop();
  const layoutId = id;
  const CurrentPath = window.location.pathname;

  const { t } = useTranslation();

  // Filter Menu Items Based on Privileges
  const filterMenuItems = (menuItems, permissions) => {
    return menuItems
      .flatMap((menuGroup) => {
        // Iterate over each group, accessing the `Items` property
        if (menuGroup.Items) {
          return menuGroup.Items.filter((menuItem) => {
            // console.log(`Checking menu key: ${menuItem.key}`);
            const privilege = permissions.find((p) => p.menu_key === menuItem.key);
            // console.log(`Privilege found for key ${menuItem.key}:`, privilege);

            if (privilege) {
              if (privilege.full_access) return true;

              if (menuItem.children && menuItem.children.length > 0) {
                menuItem.children = menuItem.children.filter((child) => {
                  // console.log(`Checking child menu key: ${child.key}`);
                  const childPrivilege = privilege.sub_permissions?.find((sp) => sp.key === child.key);
                  // console.log(`Child privilege found for key ${child.key}:`, childPrivilege);

                  if (childPrivilege) {
                    if (childPrivilege.full_access) return true;
                    if (childPrivilege.actions?.some((action) => action.allowed)) return true;
                  }
                  return false;
                });

                return menuItem.children.length > 0;
              }

              if (!menuItem.children || menuItem.children.length === 0) {
                if (privilege.actions?.some((action) => action.allowed)) {
                  return true;
                }
              }
            }

            return false;
          });
        }
        return [];
      })
      .map((menuItem) => ({ ...menuItem })); // Ensure immutability
  };

  useEffect(() => {
    if (privileges) {
      // console.log(JSON.stringify(privileges))
      // Filter the menu based on user privileges
      // const filteredMenu = filterMenuItems(MENUITEMS, privileges?.permissions || []);

      // const transformedMenu = [
      //   {
      //     Items: filteredMenu
      //   }
      // ];
      // // console.log(JSON.stringify(transformedMenu))

      // setMenu(transformedMenu);

      setMenu(MENUITEMS)
    } else {
      console.log("static menus");

      // const allowedServices = clinicAdmin.services;
      // // Clone the MENUITEMS so original reference is untouched
      // const menuCopy = JSON.parse(JSON.stringify(MENUITEMS));

      // // Find the services menu item
      // const serviceIndex = menuCopy[0].Items.findIndex(item => item.key === 'services');

      // if (serviceIndex !== -1) {
      //   // Filter children inside 'services' menu based on allowedServices
      //   const originalServices = menuCopy[0].Items[serviceIndex];

      //   const filteredChildren = originalServices.children.filter(child => {
      //     if (child.key === 'pharmacy') return allowedServices.pharmacy;
      //     if (child.key === 'laboratory') return allowedServices.laboratory;
      //     if (child.key === 'imaging') return allowedServices.imaging;
      //     if (child.key === 'special_test') return allowedServices.special_test;
      //     if (child.key === 'procedure') return allowedServices.procedure;
      //     return false;
      //   });

      //   // If no services are allowed, remove the entire services menu
      //   if (filteredChildren.length === 0) {
      //     menuCopy[0].Items.splice(serviceIndex, 1);
      //   } else {
      //     menuCopy[0].Items[serviceIndex].children = filteredChildren;
      //   }
      // }
      // setMenu(menuCopy);
      
      setMenu(MENUITEMS)
    }
  }, [privileges])

  const toggletNavActive = (item) => {
    if (window.innerWidth <= 991) {
      document.querySelector(".page-header").className = "page-header close_icon";
      document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper close_icon ";
      // document.querySelector('.mega-menu-container').classList.remove('d-block');
      if (item.type === "sub") {
        document.querySelector(".page-header").className = "page-header";
        document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper";
      }
    }
    if (!item.active) {
      menu.map((a) => {
        a.Items.filter((Items) => {
          if (a.Items.includes(item)) Items.active = false;
          if (!Items.children) return false;
          Items.children.forEach((b) => {
            if (Items.children.includes(item)) {
              b.active = false;
            }
            if (!b.children) return false;
            b.children.forEach((c) => {
              if (b.children.includes(item)) {
                c.active = false;
              }
            });
          });
          return Items;
        });
        return a;
      });
    }
    item.active = !item.active;
    setMainMenu({ mainmenu: menu });
  };

  // return (
  //   <>
  //     {menu.map((Item, i) => (
  //       <Fragment key={i}>
  //         {/* <li className="sidebar-main-title">
  //           <div>
  //             <h6 className="lan-1">{t(Item.menutitle)}</h6>
  //           </div>
  //         </li> */}
  //         {Item.Items.map((menuItem, i) => (
  //           <li className="sidebar-list" key={i}>
  //             {menuItem.type === "sub" ? (
  //               <a
  //                 href="javascript"
  //                 className={`sidebar-link sidebar-title ${CurrentPath.includes(menuItem.path) ? "active" : ""} ${menuItem.active && "active"}`}
  //                 // className={`sidebar-link sidebar-title ${CurrentPath.includes(menuItem.title.toLowerCase()) ? "active" : ""} ${menuItem.active && "active"}`}
  //                 onClick={(event) => {
  //                   event.preventDefault();
  //                   setNavActive(menuItem);
  //                   activeClass(menuItem.active);
  //                 }}>
  //                 <SvgIcon className="stroke-icon" iconId={`stroke-${menuItem.icon}`} />
  //                 <SvgIcon className="fill-icon" iconId={`fill-${menuItem.icon}`} />
  //                 <span>{t(menuItem.title)}</span>
  //                 {menuItem.badge ? <label className={menuItem.badge}>{menuItem.badgetxt}</label> : ""}
  //                 <div className="according-menu">{menuItem.active ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"></i>}</div>
  //               </a>
  //             ) : (
  //               ""
  //             )}

  //             {menuItem.type === "link" ? (
  //               <Link to={menuItem.path} className={`sidebar-link sidebar-title link-nav  ${CurrentPath.includes(menuItem.path) ? "active" : ""}`} onClick={() => toggletNavActive(menuItem)}>
  //                 <SvgIcon className="stroke-icon" iconId={`stroke-${menuItem.icon}`} />
  //                 <SvgIcon className="fill-icon" iconId={`fill-${menuItem.icon}`} />
  //                 {/* Custom Icons */}
  //                 {/* <IconRenderer iconName={menuItem.icon} className="stroke-icon" /> */}
  //                 <span>{t(menuItem.title)}</span>
  //                 {menuItem.badge ? <label className={menuItem.badge}>{menuItem.badgetxt}</label> : ""}
  //               </Link>
  //             ) : (
  //               ""
  //             )}

  //             {menuItem.children ? (
  //               <ul className="sidebar-submenu" style={layout1 !== "compact-sidebar compact-small" ? (menuItem?.active || CurrentPath.includes(menuItem?.title?.toLowerCase()) ? (sidebartoogle ? { opacity: 1, transition: "opacity 500ms ease-in" } : { display: "block" }) : { display: "none" }) : { display: "none" }}>
  //                 {menuItem.children.map((childrenItem, index) => {
  //                   return (
  //                     <li key={index}>
  //                       {childrenItem.type === "sub" ? (
  //                         <a
  //                           href="javascript"
  //                           className={`${CurrentPath.includes(childrenItem?.title?.toLowerCase()) ? "active" : ""}`}
  //                           // className={`${childrenItem.active ? 'active' : ''}`}
  //                           onClick={(event) => {
  //                             event.preventDefault();
  //                             toggletNavActive(childrenItem);
  //                           }}>
  //                           {t(childrenItem.title)}
  //                           <span className="sub-arrow">
  //                             <i className="fa fa-chevron-right"></i>
  //                           </span>
  //                           <div className="according-menu">{childrenItem.active ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"></i>}</div>
  //                         </a>
  //                       ) : (
  //                         ""
  //                       )}

  //                       {childrenItem.type === "link" ? (
  //                         <Link
  //                           to={childrenItem.path}
  //                           className={`${CurrentPath.includes(childrenItem?.path) ? "active" : ""}`}
  //                           // className={`${childrenItem.active ? 'active' : ''}`} bonusui
  //                           onClick={() => toggletNavActive(childrenItem)}>
  //                           {t(childrenItem.title)}
  //                         </Link>
  //                       ) : (
  //                         ""
  //                       )}

  //                       {childrenItem.children ? (
  //                         <ul className="nav-sub-childmenu submenu-content" style={CurrentPath.includes(childrenItem?.title?.toLowerCase()) || childrenItem.active ? { display: "block" } : { display: "none" }}>
  //                           {childrenItem.children.map((childrenSubItem, key) => (
  //                             <li key={key}>
  //                               {childrenSubItem.type === "link" ? (
  //                                 <Link
  //                                   to={childrenSubItem.path}
  //                                   className={`${CurrentPath.includes(childrenSubItem?.path) ? "active" : ""}`}
  //                                   // className={`${childrenSubItem.active ? 'active' : ''}`}
  //                                   onClick={() => toggletNavActive(childrenSubItem)}>
  //                                   {t(childrenSubItem.title)}
  //                                 </Link>
  //                               ) : (
  //                                 ""
  //                               )}
  //                             </li>
  //                           ))}
  //                         </ul>
  //                       ) : (
  //                         ""
  //                       )}
  //                     </li>
  //                   );
  //                 })}
  //               </ul>
  //             ) : (
  //               ""
  //             )}
  //           </li>
  //         ))}
  //       </Fragment>
  //     ))}
  //   </>
  // );

  return (
    <>
      {Array.isArray(menu) && menu.map((Item, i) => (
        <Fragment key={i}>
          {Array.isArray(Item.Items) && Item.Items.map((menuItem, j) => (
            <li className="sidebar-list" key={j}>
              {menuItem.type === "sub" ? (
                <a
                  href="javascript"
                  className={`sidebar-link sidebar-title ${CurrentPath.includes(menuItem.path) ? "active" : ""} ${menuItem.active ? "active" : ""}`}
                  onClick={(event) => {
                    event.preventDefault();
                    setNavActive(menuItem);
                    activeClass(menuItem.active);
                  }}
                >
                  {/* <SvgIcon className="stroke-icon" iconId={`stroke-${menuItem.icon}`} />
                  <SvgIcon className="fill-icon" iconId={`fill-${menuItem.icon}`} /> */}
                  {/* Custom Icons */}
                  <IconRenderer iconName={menuItem.icon} className="stroke-icon" />
                  <span>{t(menuItem.title)}</span>
                  {menuItem.badge && <label className={menuItem.badge}>{menuItem.badgetxt}</label>}
                  <div className="according-menu">
                    <i className={`fa ${menuItem.active ? "fa-angle-down" : "fa-angle-right"}`}></i>
                  </div>
                </a>
              ) : null}

              {menuItem.type === "link" ? (
                <Link
                  to={menuItem.path}
                  className={`sidebar-link sidebar-title link-nav ${CurrentPath.includes(menuItem.path) ? "active" : ""}`}
                  onClick={(e) => {
                    if (CurrentPath === menuItem.path) {
                      e.preventDefault(); // Prevent reloading same path
                    } else {
                      toggletNavActive(menuItem);
                    }
                  }}
                >
                  {/* <SvgIcon className="stroke-icon" iconId={`stroke-${menuItem.icon}`} />
                  <SvgIcon className="fill-icon" iconId={`fill-${menuItem.icon}`} /> */}
                  {/* Custom Icons */}
                  <IconRenderer iconName={menuItem.icon} className="stroke-icon" />
                  <span>{t(menuItem.title)}</span>
                  {menuItem.badge && <label className={menuItem.badge}>{menuItem.badgetxt}</label>}
                </Link>
              ) : null}

              {Array.isArray(menuItem.children) && menuItem.children.length > 0 ? (
                <ul
                  className="sidebar-submenu"
                  style={layout1 !== "compact-sidebar compact-small" ? (menuItem.active || CurrentPath.includes(menuItem.title.toLowerCase()) ? (sidebartoogle ? { opacity: 1, transition: "opacity 500ms ease-in" } : { display: "block" }) : { display: "none" }) : { display: "none" }}
                >
                  {menuItem.children.map((childrenItem, k) => (
                    <li key={k}>
                      {childrenItem.type === "sub" ? (
                        <a
                          href="javascript"
                          className={CurrentPath.includes(childrenItem.title.toLowerCase()) ? "active" : ""}
                          onClick={(event) => {
                            event.preventDefault();
                            toggletNavActive(childrenItem);
                          }}
                        >
                          {t(childrenItem.title)}
                          <span className="sub-arrow">
                            <i className="fa fa-chevron-right"></i>
                          </span>
                          <div className="according-menu">
                            <i className={`fa ${childrenItem.active ? "fa-angle-down" : "fa-angle-right"}`}></i>
                          </div>
                        </a>
                      ) : null}

                      {childrenItem.type === "link" ? (
                        <Link
                          to={childrenItem.path}
                          className={CurrentPath.includes(childrenItem.path) ? "active" : ""}
                          onClick={() => toggletNavActive(childrenItem)}
                        >
                          {t(childrenItem.title)}
                        </Link>
                      ) : null}

                      {Array.isArray(childrenItem.children) && childrenItem.children.length > 0 ? (
                        <ul
                          className="nav-sub-childmenu submenu-content"
                          style={CurrentPath.includes(childrenItem.title.toLowerCase()) || childrenItem.active ? { display: "block" } : { display: "none" }}
                        >
                          {childrenItem.children.map((childrenSubItem, l) => (
                            <li key={l}>
                              {childrenSubItem.type === "link" ? (
                                <Link
                                  to={childrenSubItem.path}
                                  className={CurrentPath.includes(childrenSubItem.path) ? "active" : ""}
                                  onClick={() => toggletNavActive(childrenSubItem)}
                                >
                                  {t(childrenSubItem.title)}
                                </Link>
                              ) : null}
                            </li>
                          ))}
                        </ul>
                      ) : null}
                    </li>
                  ))}
                </ul>
              ) : null}
            </li>
          ))}
        </Fragment>
      ))}
    </>
  );

};

export default SidebarMenuItems;
